import * as qsModule from 'qs';
// Little hack to ensure we are compatible with the default export of qs in NPM
const qs = qsModule.qs ? qsModule.qs : qsModule;
const inputFromSearch = (queryString) => qs.parse(queryString.toString());
const inputFromFormData = (formData) => inputFromSearch(new URLSearchParams(formData));
const inputFromForm = async (request) => inputFromFormData(await request.clone().formData());
const inputFromUrl = (request) => inputFromSearch(new URL(request.url).searchParams);
export { inputFromForm, inputFromUrl, inputFromFormData, inputFromSearch };
